import { ResponsiveComponentProps } from '@/types/other';
import React from 'react';
import WrapperResponsiveComponent from './WrapperResponsiveComponent';

export default function ResponsiveComponent({
  windowWidth,
  MobileComponent,
  DesktopComponent,
  PageLoader = null,
  loading = false,
}: ResponsiveComponentProps) {
  const MobileComponentMemo = React.useMemo(
    () => MobileComponent,
    [MobileComponent]
  );
  const DesktopComponentMemo = React.useMemo(
    () => DesktopComponent,
    [DesktopComponent]
  );

  if (!windowWidth || windowWidth <= 0) {
    return (
      <>
        <WrapperResponsiveComponent desktop={false}>
          {MobileComponentMemo}
        </WrapperResponsiveComponent>
        <WrapperResponsiveComponent desktop={true}>
          {DesktopComponentMemo}
        </WrapperResponsiveComponent>
      </>
    );
  }

  if (loading) {
    return PageLoader || null;
  }

  if (windowWidth <= 992) {
    return MobileComponentMemo;
  }

  return DesktopComponentMemo;
}
